<template>
  <form-section v-loading="loading">
    <div ref="map">
      <div class="graph"></div>
    </div>
  </form-section>
</template>
<script>
import FormSection from '@/common/components/form/FormSection'
import GeoHeatChart from '@/jquery/analytics/charts/geoHeatChart'

export default {
  name: 'ProfileLocationsMap',

  components: {
    FormSection
  },

  props: {
    profileId: {
      required: true
    },

    projectId: {
      required: true
    }
  },

  data() {
    return {
      chart: null,
      loading: true
    }
  },

  mounted() {
    this.initializeMap()

    this.$nextTick(() => {
      this.$emit('update-data', this.chart)
      this.loading = false
    })
  },

  computed: {
    mapStyles() {
      return [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        }
      ]
    }
  },

  methods: {
    initializeMap() {
      this.chart = new GeoHeatChart({
        method: 'profile_locations_map',
        element: $(this.$refs.map),
        styles: this.mapStyles
      })

      this.chart.reloadByParam(
        {},
        {
          project_id: this.projectId,
          profile_id: this.profileId
        }
      )
    },

    clickLocation(item) {
      this.chart.fitWithPositionAndRadius(
        item.latitude,
        item.longitude,
        item.radius
      )
    }
  }
}
</script>
<style scoped>
>>> .mapLegendContainer {
  background: #fff;
  border: none;
  border-radius: 3px;
  -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  margin: 10px;
  padding: 5px;
}

>>> .mapLegend {
  width: 120px;
}

>>> .mapLegendItem {
  padding: 5px;
  text-align: left;
  cursor: pointer;
}

>>> .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfileLocationsMap.vue